<script>
export default {
    components: {},
    props: {
        title: {
            type: String,
            default: "",
        },
        titoloScheda: {
            type: String,
        }
    },
    mounted() {
        let siteName;
        let documentTitle;
        // Check if $appConfig and nomeSito are defined
        if (this.$appConfig && this.$appConfig.nomeSito) {
            siteName = this.$appConfig.nomeSito;
        } else {
            siteName = 'Default Site Name';
        }
        if (this.title) {
            documentTitle = `${this.title} - ${siteName}`;
        } else if (this.titoloScheda) {
            documentTitle = `${this.titoloScheda} - ${siteName}`;
        }
        document.title = documentTitle;
    },
};
</script>

<template>
    <div v-if="title">
        <h1 style="font-weight: bold;" class="my-3 card-title-underline">{{ title }}</h1>
    </div>
</template>

<style>
.card-title-underline {
    display: inline-block;
    position: relative;
    padding: 5px;
    width: 100%;
    max-width: 1200px;
}

.card-title-underline::after {
    content: '';
    display: block;
    width: 20%;
    height: 3px;
    background-color: #17a2b8; /* Bootstrap "info" color */
    position: absolute;
    left: 0;
    bottom: -2px;
}

.card-title-underline::before {
    content: '';
    display: block;
    width: 60%;
    height: 1px;
    background-color: #ccc; /* Light gray for the rest of the underline */
    position: absolute;
    left: 0;
    bottom: -2px;
}
</style>
